// uncomment the wdyr import to enable why-did-you-render
// import '@/wdyr'; // Note this must be the first import for it to work
import '@/styles';
import momentDurationFormatSetup from 'moment-duration-format';
import moment from 'moment-timezone';
import { Profiler, type ProfilerOnRenderCallback } from 'react';
import { createRoot } from 'react-dom/client';
import { patchGlobalResizeObserver } from '@/core/PatchedResizeObserver';
import { isSystemTest } from '@/core/utilities';
import { Application } from '@/main/Application.page';
import { headlessRenderMode } from '@/services/headlessCapture.utilities';
import { registerSeeqTelemetryErrorHandlers } from '@/utilities/telemetryErrorHandlers';

// Must run before any logging or error capture so Seeq-specific recognizers/scrubbers are in
// place for the first log/error that gets serialized.
registerSeeqTelemetryErrorHandlers();

// Patch ResizeObserver before any components are created
// This ensures all ResizeObserver instances (including those created during initial render)
// are wrapped to prevent "loop completed with undelivered notifications" errors
patchGlobalResizeObserver();

// https://github.com/seeq12/crab/pull/5962/files#r1446538620
momentDurationFormatSetup(moment as any);

const rootEl = document.getElementById('sqApp') || document.createElement('div');
if (isSystemTest() || headlessRenderMode()) {
  rootEl.classList.add('isHeadlessMode');
}
const root = createRoot(rootEl);

async function renderApplication() {
  // oxlint-disable-next-line no-undef
  if (__PERFORMANCE_LOGGING_BUILD__) {
    const { installRenderPerf } = await import('@/core/renderPerf');
    const onRender: ProfilerOnRenderCallback = installRenderPerf();
    root.render(
      <Profiler id="Application" onRender={onRender}>
        <Application />
      </Profiler>,
    );
    return;
  }

  root.render(<Application />);
}

void renderApplication();
